const REVIEWS = {
fr: [
  { name: "Thomas Renard", role: "Directeur PME, Bruxelles", rating: 5, text: "Excellent logiciel de paie belge. La Dimona automatique nous fait gagner un temps précieux chaque mois. L'intégration avec WinBooks fonctionne parfaitement.", date: "Mars 2026" },
  { name: "Nathalie Bodart", role: "Responsable RH, Liège", rating: 5, text: "Très bonne solution pour notre PME de 28 personnes. La gestion des fiches de paie est entièrement automatisée. Support technique réactif et compétent.", date: "Mars 2026" },
  { name: "Sophie Lecomte", role: "Fiduciaire, Namur", rating: 5, text: "En tant que fiduciaire, j'ai testé beaucoup de logiciels de paie. Aureus Social Pro est de loin le plus moderne. Interface intuitive et les calculs sont toujours justes.", date: "Mars 2026" },
  { name: "Pierre Masson", role: "Expert-comptable, Gand", rating: 5, text: "Notre fiduciaire gère maintenant 40 dossiers clients via Aureus. Le gain de temps est énorme. Je recommande vivement.", date: "Mars 2026" },
  { name: "Isabelle Collin", role: "DRH, Bruxelles", rating: 5, text: "L'agent IA juridique est impressionnant. Il répond aux questions de droit social belge en quelques secondes, avec les références légales exactes.", date: "Fév. 2026" },
  { name: "Laurent Dupont", role: "Gérant, Charleroi", rating: 5, text: "Onboarding rapide. En moins d'une semaine, tous nos dossiers étaient migrés. Le calcul des aides Activa.brussels est automatique, c'est top.", date: "Fév. 2026" },
  { name: "Céline Peeters", role: "Office Manager, Anvers", rating: 4, text: "Super logiciel, très complet. La gestion des commissions paritaires est excellente. Petit bémol sur la courbe d'apprentissage mais le support est très disponible.", date: "Fév. 2026" },
  { name: "Frederic Jacobs", role: "Dirigeant, Louvain", rating: 5, text: "Aureus Social Pro a transformé notre gestion RH. Les fiches de paie sont générées en quelques clics et les déclarations ONSS partent automatiquement.", date: "Fév. 2026" },
  { name: "Amandine Dubois", role: "Gérante restaurant, Bruxelles", rating: 5, text: "Parfait pour notre restaurant de 18 personnes. La gestion des flexi-jobs et des étudiants est très bien faite. Les cotisations réduites sont appliquées automatiquement.", date: "Jan. 2026" },
  { name: "Gregory Mathieu", role: "Fiduciaire, Liège", rating: 5, text: "Excellent outil pour une fiduciaire. La gestion multi-clients est native et bien pensée. L'export vers Bob50 fonctionne parfaitement.", date: "Jan. 2026" },
  { name: "Romain Charlier", role: "Directeur RH, Mons", rating: 5, text: "Le meilleur logiciel de paie belge que j'ai utilisé en 15 ans de carrière RH. Tout est automatisé et conforme. La veille légale quotidienne est un vrai plus.", date: "Oct. 2025" },
],
nl: [
  { name: "Thomas Renard", role: "Directeur KMO, Brussel", rating: 5, text: "Uitstekende Belgische loonsoftware. De automatische Dimona bespaart ons elke maand kostbare tijd. De integratie met WinBooks werkt perfect.", date: "Maart 2026" },
  { name: "Nathalie Bodart", role: "HR-verantwoordelijke, Luik", rating: 5, text: "Zeer goede oplossing voor onze KMO van 28 personen. Het beheer van loonfiches is volledig geautomatiseerd. Reactieve en competente technische ondersteuning.", date: "Maart 2026" },
  { name: "Sophie Lecomte", role: "Fiduciaire, Namen", rating: 5, text: "Als fiduciaire heb ik veel loonsoftware getest. Aureus Social Pro is veruit de meest moderne. Intuïtieve interface en de berekeningen kloppen altijd.", date: "Maart 2026" },
  { name: "Pierre Masson", role: "Boekhouder, Gent", rating: 5, text: "Ons kantoor beheert nu 40 klantendossiers via Aureus. De tijdswinst is enorm. Ik beveel het ten zeerste aan.", date: "Maart 2026" },
  { name: "Isabelle Collin", role: "HRD, Brussel", rating: 5, text: "De AI juridische assistent is indrukwekkend. Hij beantwoordt vragen over Belgisch sociaal recht in enkele seconden, met de exacte wettelijke referenties.", date: "Feb. 2026" },
  { name: "Laurent Dupont", role: "Zaakvoerder, Charleroi", rating: 5, text: "Snelle onboarding. In minder dan een week waren al onze dossiers gemigreerd. De berekening van Activa.brussels-premies is automatisch, top!", date: "Feb. 2026" },
  { name: "Céline Peeters", role: "Office Manager, Antwerpen", rating: 4, text: "Geweldige software, zeer compleet. Het beheer van paritaire comités is uitstekend. Kleine kanttekening bij de leercurve, maar de ondersteuning is zeer beschikbaar.", date: "Feb. 2026" },
  { name: "Frederic Jacobs", role: "Directeur, Leuven", rating: 5, text: "Aureus Social Pro heeft ons HR-beheer getransformeerd. Loonfiches worden in enkele klikken gegenereerd en RSZ-aangiften vertrekken automatisch.", date: "Feb. 2026" },
  { name: "Amandine Dubois", role: "Zaakvoerder restaurant, Brussel", rating: 5, text: "Perfect voor ons restaurant met 18 personen. Het beheer van flexi-jobs en studenten is zeer goed uitgewerkt. Verminderde bijdragen worden automatisch toegepast.", date: "Jan. 2026" },
  { name: "Gregory Mathieu", role: "Fiduciaire, Luik", rating: 5, text: "Uitstekende tool voor een fiduciaire. Multi-klantenbeheer is native en goed doordacht. De export naar Bob50 werkt perfect.", date: "Jan. 2026" },
  { name: "Romain Charlier", role: "HR-directeur, Bergen", rating: 5, text: "De beste Belgische loonsoftware die ik in 15 jaar HR-carrière heb gebruikt. Alles is geautomatiseerd en conform. De dagelijkse wettelijke monitoring is een echte meerwaarde.", date: "Okt. 2025" },
],
};

const LABELS = {
  fr: { eyebrow: 'Témoignages clients', title: 'Ce que disent nos clients', outOf: 'sur 5', reviews: 'avis', cta: 'Rejoindre nos clients satisfaits →' },
  nl: { eyebrow: 'Klantengetuigenissen', title: 'Wat onze klanten zeggen', outOf: 'op 5', reviews: 'beoordelingen', cta: 'Sluit u aan bij onze tevreden klanten →' },
};

// Couleurs pleines réservées au mode dark (déjà ≥4.5:1 sur fond #1a1a16/#141410) ;
// en mode clair (cardBg blanc), assombries pour atteindre 4.5:1 texte / 3:1 objet
// graphique WCAG AA — voir audit contraste, point 9 des 20 points.
const STAR_FILL = { light: '#ce8509', dark: '#f59e0b' };
const STAR_EMPTY = { light: '#96948f', dark: '#e0ddd5' };

function Stars({ n, dark = false }) {
  const fill = dark ? STAR_FILL.dark : STAR_FILL.light;
  const empty = dark ? STAR_EMPTY.dark : STAR_EMPTY.light;
  return (
    <div style={{ display: 'flex', gap: 2, marginBottom: 10 }}>
      {[1,2,3,4,5].map(i => (
        <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill={i <= n ? fill : empty}>
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ))}
    </div>
  );
}

function Avatar({ name }) {
  const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
  // Palette assombrie pour un ratio ≥4.5:1 avec le texte blanc des initiales
  // (mesuré : l'originale échouait sur 8/8 teintes, 2.15-3.68:1).
  const colors = ['#3574db','#8558ec','#178841','#a46a07','#cd3f85','#048197','#d73d3d','#0c875e'];
  const color = colors[name.charCodeAt(0) % colors.length];
  return (
    <div style={{
      width: 44, height: 44, borderRadius: '50%',
      background: color, color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontWeight: 800, fontSize: 15, flexShrink: 0,
    }}>{initials}</div>
  );
}

export default function Testimonials({ max = 6, dark = false, lang = 'fr' }) {
  const reviews = REVIEWS[lang] || REVIEWS.fr;
  const labels = LABELS[lang] || LABELS.fr;
  const shown = reviews.slice(0, max);
  const avg = (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1);

  const bg = dark ? '#141410' : '#f9f7f2';
  const cardBg = dark ? '#1a1a16' : '#fff';
  const cardBorder = dark ? '#2a2a24' : '#e8e4d8';
  const textColor = dark ? '#ccc' : '#555';
  const titleColor = dark ? '#fff' : '#1a1a18';
  // #c6a34e passe déjà (7.7-8.1:1) sur les fonds sombres #141410/#1a1a16 ; en clair
  // (sur #f9f7f2/#fff) il tombe à 2.2-2.4:1, assombri ici pour repasser 4.5:1.
  const goldColor = dark ? '#c6a34e' : '#876f35';
  const roleColor = dark ? '#888' : '#767676';
  const starFill = dark ? STAR_FILL.dark : STAR_FILL.light;

  return (
    <section style={{ background: bg, padding: '64px 24px', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: goldColor, textTransform: 'uppercase', letterSpacing: 2, marginBottom: 8 }}>
            {labels.eyebrow}
          </div>
          <h2 style={{ fontSize: 30, fontWeight: 900, color: titleColor, margin: '0 0 12px' }}>
            {labels.title}
          </h2>
          {/* Note globale */}
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12, background: cardBg, border: `1px solid ${cardBorder}`, borderRadius: 40, padding: '10px 24px' }}>
            <div style={{ display: 'flex', gap: 2 }}>
              {[1,2,3,4,5].map(i => (
                <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill={starFill}>
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              ))}
            </div>
            <span style={{ fontSize: 22, fontWeight: 900, color: goldColor }}>{avg}</span>
            <span style={{ fontSize: 14, color: textColor }}>{labels.outOf} · {reviews.length} {labels.reviews}</span>
          </div>
        </div>

        {/* Grille avis */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20 }}>
          {shown.map(({ name, role, rating, text, date }) => (
            <div key={name} style={{
              background: cardBg, border: `1px solid ${cardBorder}`,
              borderRadius: 14, padding: 24,
              display: 'flex', flexDirection: 'column', gap: 12,
            }}>
              <Stars n={rating} dark={dark} />
              <p style={{ fontSize: 14, color: textColor, lineHeight: 1.7, margin: 0, flex: 1 }}>
                &ldquo;{text}&rdquo;
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 4 }}>
                <Avatar name={name} />
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: titleColor }}>{name}</div>
                  <div style={{ fontSize: 12, color: roleColor }}>{role} · {date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ textAlign: 'center', marginTop: 40 }}>
          <a href="/demo" style={{
            display: 'inline-block', background: '#c6a34e', color: '#1a1a18',
            fontWeight: 800, padding: '14px 32px', borderRadius: 10,
            textDecoration: 'none', fontSize: 15,
          }}>
            {labels.cta}
          </a>
        </div>
      </div>
    </section>
  );
}
